import { Image } from '@tiptap/extension-image';

const CustomImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      // width: {
      //   default: null,
      //   parseHTML: element => element.getAttribute('width'),
      //   renderHTML: attributes => {
      //     if (!attributes.width) return {};
      //     return { width: attributes.width };
      //   },
      // },
      // height: {
      //   default: null,
      //   parseHTML: element => element.getAttribute('height'),
      //   renderHTML: attributes => {
      //     if (!attributes.height) return {};
      //     return { height: attributes.height };
      //   },
      // },
      width: {
        default: null,
        renderHTML: attributes => attributes.width ? { style: `width: ${attributes.width}` } : {},
      },
      height: {
        default: null,
        renderHTML: attributes => attributes.height ? { style: `height: ${attributes.height}` } : {},
      },
    };
  },
});

export default CustomImage;
